import {
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Td,
  Textarea,
  Tr,
  useToast,
  Text,
  useMediaQuery,
  useColorModeValue,
  Badge,
  Tooltip,
  IconButton,
  Box,
  Flex
} from "@chakra-ui/react";
import React from "react";
import { useState, useRef, useContext, useEffect } from 'react';
import { AppContext } from "../context/AppContext";
import { GiSandsOfTime } from 'react-icons/gi';
import { FiCopy, FiX, FiCheck, FiClock, FiRefreshCw } from "react-icons/fi";
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { BsCheckCircle } from 'react-icons/bs';
import { CancelOtpAPI, CheckOTPAPI } from "../utils/api";
function getRemainingTimeInSeconds(backendTimeISO, server) {
  // Parse the backend ISO time string (always in UTC)
  let backendTime = new Date(backendTimeISO);

  // Get current time in the browser's local timezone
  let currentTime = new Date();

  // Calculate the time difference in milliseconds
  let diffMs = currentTime - backendTime;

  // 20 minutes in milliseconds
  const twentyMinutesMs = server == 'server5' || server === 'server3' ? 5 * 60 * 1000 : server === 'server1' ? 15 * 60 * 1000 : 20 * 60 * 1000;

  // If less than 20 minutes passed, return remaining seconds
  if (diffMs < twentyMinutesMs) {
    return Math.floor((twentyMinutesMs - diffMs) / 1000);
  } else {
    return 0;
  }
}

function extractOTP(message) {
  const match = message.match(/\b\d{4,6}\b/);
  return match ? match[0] : null;
}
const formatTime = time => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
const OtpHistoryCard = ({ serviceName, otpMessages, mobile, createdAt, time, price, status, mobileId, serialNumber, handleOTPCancel, handleOTPMessage, server, businessCode, cancelBtnRequestInProgress, setCancelBtnRequestInProgress }) => {
  const { setBalance, Token, handleLogout } = useContext(AppContext);
  const toast = useToast();
  const [remainingTime, setRemainingTime] = useState(getRemainingTimeInSeconds(createdAt, server));
  const [isLargerThan650] = useMediaQuery("(min-width: 650px)");
  const [showTime, setShowTime] = useState(false);
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [expired, setExpired] = useState(false);
  const [resend, setResend] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [showTimeOnResend, setShowTimeOnResend] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(false);
  const doWeNeedResend = (status !== "cancelled" && (server == 'server1' || server == 'server2'));
  const resendCooldownTimer = useRef(null);
  const requestRef = useRef(false);
  const [ws, setws] = useState(null);
  const [currentNumber, setCurrentNumber] = useState({
    serialNumber: "",
    mobileno: "",
    mobileId: "",
  });
  const [copiedText, setCopiedText] = useState("");

  // Premium UI Colors
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const textColor = useColorModeValue("gray.700", "gray.200");

  // const serialNumberRef = useRef(null);
  const CopyToClipBoard = () => {
    let numberForCopy = "";
    for (let i = 3; i < mobile.length; i++) {
      numberForCopy += mobile[i];
    }
    if (mobile != "") {
      navigator.clipboard
        .writeText(numberForCopy)
        .then(() => {
          toast({
            status: "success",
            title: `${numberForCopy} copied to clipboard`,
            isClosable: true,
            duration: 1500,
            position: "bottom",
          });
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
          toast({
            status: "error",
            title: "Error copying number",
            isClosable: true,
            duration: 1500,
          });
        });
    }
  };
  const copyToClipboardOtp = (text) => {
    let numberForCopy = "";
    numberForCopy = extractOTP(text);
    setCopiedText("OTP");
    setTimeout(() => setCopiedText(""), 2000);
    navigator.clipboard
      .writeText(numberForCopy)
      .then(() => {
        toast({
          status: "success",
          title: "Otp copied",
          isClosable: true,
          duration: 1500,
          position: "bottom",
        });
      })
      .catch((error) => {
        console.error(error, "error in copying");
      });
  };
  const handleOTP = (myResend = false, socket) => {
    if (serialNumber != "" && socket) {
      CheckOTPAPI(
        socket,
        {
          serialNumber,
          mobileId,
          businessCode,
          server,
          resend: myResend
        },
      )
        .then((res) => {
          requestRef.current = true;
          if (res && res.message == "OTP Successfully Generated!") {
            let otpMessage = res.otpMessage;
            handleOTPMessage(mobileId, otpMessage);
            setResendLoading(false);
            toast({
              title: "Otp fetched successfully",
              description: "Now you can use this otp into your service",
              status: "success",
              isClosable: true,
              duration: 2000,
            });
            setShowTime(false);
            if (server == "server1" || server == "server2") {
              setResend(true);
            }
            setShowTimeOnResend(false);
            if (resendCooldownTimer.current) {
              setResendCooldown(false);
              clearTimeout(resendCooldownTimer.current);
              resendCooldownTimer.current = null;
            }
          };
        })
        .catch((err) => {
          setResendLoading(false);
          console.log(err, "error saying");
          setShowTime(false);
          handleLogout(err);
        });
    }
  };
  const startChecking = (myResend = false) => {
    const socket = new WebSocket(
      `${process.env.REACT_APP_WS_API}/check-otp?token=${Token}`
    );
    setTimeout(() => {
      if (socket) {
        setws(socket);
        console.log("start checking for otp ....");
        handleOTP(myResend, socket);
      }
    }, 5000)
  };
  const cancelBtn = async () => {
    if (cancelBtnRequestInProgress) {
      return;
    }
    if (ws) {
      ws?.close();
      console.log("ws connection closed for ", currentNumber.mobileno);
    }
    setCancelBtnRequestInProgress(true);
    try {
      let res = await CancelOtpAPI({
        serialNumber,
        server,
        mobileId
      }, Token)
      toast({
        title: `Otp request canceled`,
        status: "warning",
        isClosable: true,
      });
      setShowTime(false);
      setResend(false);
      setResendLoading(false);
      handleOTPCancel(mobileId);
      setBalance(res.data.balance);
    } catch (error) {
      handleLogout(error)
    } finally {
      setTimeout(() => {
        setCancelBtnRequestInProgress(false);
      }, 2000);
    }
  };
  useEffect(() => {
    let myInitialTime = getRemainingTimeInSeconds(createdAt, server);
    if (myInitialTime > 0 && (status == 'pending' || doWeNeedResend)) {
      setShowTimeOnResend(false);
      setResend(false);
      if (doWeNeedResend && status == 'success') {
        setResend(true);
      }
      setShowTime(true);
      startChecking(false);
    }
  }, []);
  useEffect(() => {
    if (showTime && remainingTime > 0 && status == 'pending') {
      const intervalId = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [showTime, remainingTime]);
  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    }
  }, []);
  return (
    <Tr
      _hover={{ bg: hoverBg }}
      transition="all 0.2s"
      borderBottom="1px solid"
      borderColor={borderColor}
    >

      <Td textAlign="center" py={4}>
        {(showTime || showTimeOnResend) && (
          <Badge
            colorScheme="red"
            variant="solid"
            rounded="full"
            px={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            mx="auto"
            mb="0.5rem"
            w="fit-content"
          >
            <FiClock size={12} />
            {formatTime(remainingTime)}
          </Badge>
        )}
        {status == 'pending' && (
          <Button
            size="sm"
            colorScheme="red"
            variant="outline"
            onClick={cancelBtn}
            isDisabled={(remainingTime > ((server == 'server5' || server == 'server3') ? 240 : server === "server1" ? 780 : 1080) && remainingTime < 1200) || cancelBtnRequestInProgress}
            leftIcon={<FiX />}
            _hover={{ bg: "red.50" }}
            w="100px"
          >
            Cancel
          </Button>
        )}

        {resend && remainingTime > 0 ? (
          <Button
            isDisabled={resendCooldown}
            onClick={() => {
              setShowTime(true);
              startChecking(true);
              setShowTimeOnResend(true);
              if (resendCooldownTimer.current) clearTimeout(resendCooldownTimer.current);
              setResendCooldown(true);
              resendCooldownTimer.current = setTimeout(() => {
                setResendCooldown(false);
                resendCooldownTimer.current = null;
              }, 130000);
            }}
            size="sm"
            colorScheme="blue"
            leftIcon={<FiRefreshCw />}
            w="100px"
            ml={2}
          >
            Resend
          </Button>
        ) : (status == "cancelled" && remainingTime <= 1) && (
          <Text fontSize="xs" color="gray.400">
            No actions
          </Text>
        )}
      </Td>

      <Td textAlign="center" fontWeight="600" color="brand.500" py={4}>
        {serviceName}
      </Td>

      <Td textAlign="center" fontWeight="bold" py={4}>
        ₹{price}
      </Td>

      <Td textAlign="center" py={4}>
        <InputGroup size="sm" width="fit-content" mx="auto">
          <Input
            value={mobile}
            readOnly
            textAlign="center"
            bg={useColorModeValue("white", "gray.700")}
            border="1px solid"
            borderColor={useColorModeValue("gray.300", "gray.600")}
            rounded="md"
            fontSize="sm"
            width="auto"
            htmlSize={13}
            pr="1rem"
            pl={'0rem'}
          />
          <InputRightElement width="2rem">
            <IconButton
              aria-label="Copy number"
              icon={<FiCopy />}
              size="xs"
              variant="ghost"
              color="gray.500"
              onClick={CopyToClipBoard}
              _hover={{ color: "brand.500", bg: "transparent" }}
            />
          </InputRightElement>
        </InputGroup>
      </Td>

      <Td textAlign="center" py={4}>
        <Flex justify="center" align="center">
          {status == 'pending' ? (
            <Tooltip label="Waiting for OTP" hasArrow>
              <Box>
                <GiSandsOfTime size={20} color="#F6E05E" />
              </Box>
            </Tooltip>
          ) : status == 'success' ? (
            <Tooltip label="OTP Received" hasArrow>
              <Box>
                <BsCheckCircle size={20} color="#48BB78" />
              </Box>
            </Tooltip>
          ) : (
            <Tooltip label="Cancelled" hasArrow>
              <Box>
                <AiOutlineCloseCircle size={22} color="#F56565" />
              </Box>
            </Tooltip>
          )}
        </Flex>
      </Td>

      <Td textAlign="center" py={4}>
        <Box position="relative">
          <Textarea
            width="100%"
            minW="180px"
            value={otpMessages?.map((el) => el.otpMessage)?.join(" | ")}
            readOnly
            size="xs"
            rows={1}
            fontSize={'0.7rem'}
            resize="none"
            bg={useColorModeValue("gray.50", "gray.700")}
            border="none"
            rounded="md"
            color={textColor}
            _focus={{ boxShadow: "none" }}
            minH="40px"
            py={1}
          />
          <IconButton
            aria-label="Copy full message"
            onClick={() =>
              copyToClipboardOtp(
                otpMessages[otpMessages.length - 1].otpMessage
              )
            }
            icon={copiedText === "OTP" ? <FiCheck /> : <FiCopy />}
            position="absolute"
            bottom={'0'}
            right={'0rem'}
            p="1"
            size="xs"
            bg="white"
            _dark={{ bg: "gray.800" }}
            rounded="md"
            boxShadow="sm"
            transition="background-color 0.2s"
            color={copiedText === "OTP" ? "green.500" : "inherit"}
            _hover={{
              bg: "gray.200",
              _dark: { bg: "gray.600" },
            }}
          />
        </Box>
      </Td>

      <Td textAlign="center" fontSize="sm" color={textColor} py={4}>
        {!isLargerThan650 ? (
          <Box>
            <Text fontWeight="bold">{time.split(" : ")[0]}</Text>
            <Text fontSize="xs" color="gray.500">{time.split(" : ")[1]}</Text>
          </Box>
        ) : (
          time
        )}
      </Td>

    </Tr>
  );
};

export default OtpHistoryCard;
